function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.591,0a15.592,15.592,0,0,0-4.931,30.384c.78.136,1.072-.331,1.072-.741,0-.37-.019-1.6-.019-2.9-3.917.721-4.931-.955-5.243-1.832a5.669,5.669,0,0,0-1.6-2.2c-.546-.292-1.325-1.013-.019-1.033a3.12,3.12,0,0,1,2.4,1.6,3.333,3.333,0,0,0,4.541,1.286,3.28,3.28,0,0,1,.994-2.085c-3.469-.39-7.094-1.735-7.094-7.7a6.068,6.068,0,0,1,1.6-4.19,5.6,5.6,0,0,1,.156-4.132s1.306-.409,4.288,1.6a14.7,14.7,0,0,1,7.8,0c2.982-2.027,4.288-1.6,4.288-1.6a5.6,5.6,0,0,1,.156,4.132,6.033,6.033,0,0,1,1.6,4.19c0,5.983-3.645,7.309-7.114,7.7a3.692,3.692,0,0,1,1.052,2.884c0,2.085-.019,3.761-.019,4.288,0,.409.292.9,1.072.741A15.6,15.6,0,0,0,15.591,0Z",
  fill: "#eceef1",
  fillRule: "evenodd"
});

function SvgGithubLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.183,
    height: 30.414,
    viewBox: "0 0 31.183 30.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/githubLogo.e586f321.svg";
export { ForwardRef as ReactComponent };